import { AgentProject } from '../agent-project/agent-project.js'
import { ADK_VERSION, formatCode } from './utils.js'
import { createFile } from '../utils/fs.js'
import path from 'path'

export async function generateEventTypes(project: AgentProject): Promise<void> {
  // Collect all integration events
  const integrationEvents: string[] = []

  for (const int of project.integrations) {
    // const intf = project.integrations.find(x => x.definition.)

    for (const event in int.definition?.events || []) {
      integrationEvents.push(`  "${int.alias}:${event}": Integrations["${int.alias}"]["events"]["${event}"];`)
    }
  }

  const content = `
////////////////////////////////////////////////////////
// DO NOT EDIT THIS FILE DIRECTLY
// This file is auto-generated from the Botpress ADK
// ADK Version: ${ADK_VERSION}
// Generated at: ${new Date().toISOString()}
////////////////////////////////////////////////////////

type Integrations = import("@botpress/runtime/_types/integrations").Integrations;

declare module "@botpress/runtime/_types/events" {
  /**
   * Global Events type that includes all integration events.
   * Use this type to reference any event that can occur in the system.
   * 
   * Events are namespaced by their source:
   * - Integration events: "<integration>:<eventName>" (e.g., "linear:issueCreated")
   * - Built-in events: Will be added in format "workflow:<name>:finished", "agent:deployed", etc.
   */
  export type Events = {
${integrationEvents.join('\n')}
  };

  // Export helper type for event names
  export type EventName = keyof Events;

  // Export helper to get event payload type
  export type EventPayload<T extends EventName> = Events[T];
}
`

  // Write to event-types.d.ts in the .adk folder
  const eventTypesPath = path.join(project.path, '.adk', 'event-types.d.ts')
  await createFile(eventTypesPath, await formatCode(content))
}
